<template>
  <div class="card-body">
    <h1 class="text-muted text-center">
      {{ isEdit ? this.$t('message.users.message.editUser') : this.$t('message.users.message.newUser') }}
    </h1>

    <div class="creation-body">
      <app-stepper-section :label="$t('message.generics.message.generalData')">
        <text-field ref="firstInput"
                      :label="$t('message.users.message.accountName')"
                      name="Nome da Conta"
                      :value="value.name"
                      validate="required|max:30"
                      @input="update('name', $event)"></text-field>

        <text-field :label="$t('message.generics.message.email')"
                      name="E-mail"
                      validate="required"
                      :value="value.email"
                      :disabled="userBeingEditedISsoUser"
                      @input="update('email', $event)"></text-field>

        <text-field :label="$t('message.loginPersonalize.message.telephone')"
                      :name="$t('message.loginPersonalize.message.telephone')"
                      :value="value.phoneNumber"
                      mask="(##) #####-####"
                      @input="update('phoneNumber', $event)"></text-field>

        <text-field :label="$t('message.generics.message.role')"
                      :name="$t('message.generics.message.role')"
                      :value="value.role"
                      @input="update('role', $event)"></text-field>

      </app-stepper-section>

      <div class="creation-body-action"
           v-if="isEdit && userBeingEditedIsAdmin">
           <div class="toggle-container">
             <toggle :value="canReadClientData"
                     @input="$emit('alter-permission')"></toggle>
              <span>{{ $t('message.users.message.viewClientsData') }}</span>
           </div>
      </div>

      <div class="creation-body-action"
           v-if="isEdit && !hasLastLogin && !userBeingEditedISsoUser">
        <app-button class="btn btn-round btn-primary"
                    :label="$t('message.users.message.resendWelcomeEmail')"
                    small
                    @click="resendWelcomeEmail()"></app-button>
      </div>

      <div class="creation-body-action"
           v-if="isEdit && (isAdmin || isMaster) && !userBeingEditedISsoUser">
        <app-button class="btn btn-round btn-primary"
                    :label="$t('message.users.message.passwordResetLink')"
                    small
                    @click="getPasswordRecoveryLink()">{{$t('message.users.message.passwordResetLink')}}</app-button>
      </div>

      <div class="creation-body-action"
           v-if="isBlocked">
        <app-button :label="$t('message.users.message.unblockUser')"
                    class="btn btn-round btn-primary"
                    primary
                    small
                    @click="unlockLogin()">{{$t('message.users.message.unblockUser')}}</app-button>
      </div>

    </div>

  </div>
</template>

<script>
import TextField from "@components/form/TextField.vue";
import AppButton from "@/components/generic/button/Button";
import AppStepperSection from "@components/StepperSection";
import EventBus from "@packages/event-bus/index";
import Toggle from "../../../components/Toggle.vue";

export default {
  components: {
    AppStepperSection,
    AppButton,
    Toggle,
    TextField
  },

  props: {
    value: {
      type: Object,
    },
    show: {
      type: Boolean,
    },
    isEdit: {
      type: Boolean,
    },
    user: {
      type: Object,
    },
  }, 

  data() {
    return {};
  },

  computed: {
    isBlocked() {
      return !!this.user && this.user.isBlocked;
    },
    hasLastLogin() {
      return !!this.user && !!this.user.lastLogin;
    },
    isAdmin() {
      return this.$store.state.users.admin && !this.$store.state.users.user;
    },
    permissions() {
      return this.$store.state.users.user.permissions;
    },
    isMaster() {
      return this.permissions.includes("MASTER");
    },
    canReadClientData() {
      return this.user.permissions.includes('READ_CLIENT_DATA')
    },
    userBeingEditedIsAdmin() {
      return (this.user && this.user.userType === "ADMIN")
    },
    userBeingEditedISsoUser() {
      return (this.user && this.user.ssoUser)
    }

  },

  methods: {
    async resendWelcomeEmail() {
      try {
        await this.$api.auth.resendWelcomeEmail({
          id: this.user.id,
        });

        EventBus.$emit("show-message", {
          type: "SUCCESS",
          message: this.$t('message.successMessages.message.welcomeEmailResent'),
          timeout: 2000,
        });
      } catch (error) {
        console.log(error);
      }
    },
    async getPasswordRecoveryLink() {
      try {
        const res = await this.$api.auth.getPasswordRecoveryLink({
          id: this.user.id,
        });

        await navigator.clipboard.writeText(res);

        EventBus.$emit("show-message", {
          type: "SUCCESS",
          message:
              this.$t('message.successMessages.message.redefinitionLink'),
        });
      } catch (error) {
        console.log(error);
      }
    },
    async validate() {
      await this.$validator.validateAll();

      console.log(this.$validator.errors)

      if (this.$validator.errors.items.length !== 0)
        return this.$emit("to-general-tab");

      this.$emit("valid");
    },
    update(key, value) {
      this.$emit("input", { ...this.value, [key]: value });
    },

    async unlockLogin() {
      const res = await this.$api.auth.unlockLogin({ id: this.user.id });

      EventBus.$emit("show-message", {
        type: "SUCCESS",
        message: res.message,
        timeout: 2000,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@variables";

.card-body {
  padding: 18px 50px 10px;

  .v-input {
    margin: 12px 0 10px 0;
  }

  .creation-body {
    .creation-body-timeout {
      margin-right: 10px;
    }

    .stepper-section {
      margin-bottom: 20px;
    }

    .dropdown {
      margin-bottom: 10px;
    }

    .creation-body-action {
      margin-bottom: 15px;
      display: flex;
      justify-content: center;

      .toggle-container {
        display: flex;
        gap: 10px;
        align-items: center;
      }
    }
  }
}
</style>
